require.register("app/supplier/show/StatTab", function(exports, require, module){
  $0
  
});

